import * as React from 'react';
export const arrowsInwardSvg = React.forwardRef(function arrowsInwardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.5 2h-9A1.5 1.5 0 0 0 2 3.5v9A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2ZM3.5.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3h-9Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 8a.75.75 0 0 0 0 1.5h1.44l-2.47 2.47a.75.75 0 1 0 1.06 1.06l2.47-2.47V12A.75.75 0 0 0 8 12V8.75A.75.75 0 0 0 7.25 8H4Zm4.75 0H12a.75.75 0 0 0 0-1.5h-1.44l2.47-2.47a.75.75 0 0 0-1.06-1.06L9.5 5.44V4A.75.75 0 0 0 8 4v3.25a.75.75 0 0 0 .75.75Z',
    }),
  );
});
arrowsInwardSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowsInward = {
  category: 'icon',
  colorable: true,
  name: 'arrowsInward',
  svg: arrowsInwardSvg,
};
